import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';
import style from '@/views/components/linkForm/style.vue';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
  components: {},
  mixins: [style],
})
export default class ChildList extends IPSDialog {
  title = '二级列表';

  dataList = [];

  vGuiderId = 0;

  sort = 0;

  order = 0;

  confirm = false;

  mounted() {
    this.getData();
  }

  getData() {
    IPSService.reportGuiderChildList({
      postParams: {
        vGuiderId: this.vGuiderId,
        order: this.order,
      },
    }).then(
      (response) => {
        this.dataList = response.list;
      },
      () => {},
    );
  }

  /**
   * 点击排序
   * @param column 点击列的信息
   */
  onSortChange(column) {
    switch (column.prop) {
      case 'childGoodsNum':
        this.order = column.order === 'ascending' ? 1 : 2;
        break;
      case 'childPrice':
        this.order = column.order === 'ascending' ? 3 : 4;
        break;
      case 'superior':
        this.order = column.order === 'ascending' ? 5 : 6;
        break;
      default:
        break;
    }
    this.getData();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="tableWrapper width-100">
          <el-table data={this.dataList} height="350px" class="width-100" tooltip-effect="light" on-sort-change={this.onSortChange.bind(this)}>
            <el-table-column type="index" label="ID" width="55" align="center" />
            <el-table-column prop="buyerName" width="80" label="姓名" show-overflow-tooltip {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span v-encrypt={{ data: scope.row.buyerName, type: 'name' }}> {scope.row.buyerName} </span>
                  );
                },
              },
            }} />
            <el-table-column prop="buyerPhone" width="180" label="手机号" show-overflow-tooltip {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span v-encrypt={{ data: scope.row.buyerPhone, type: 'phone' }}> {scope.row.buyerPhone} </span>
                  );
                },
              },
            }} />
            <el-table-column
              prop="siteCode"
              width="160"
              label="所属网点"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        [{scope.row.siteCode}]{scope.row.siteName}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="policyType"
              width="100"
              label="分销类型"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div>{['顾客分销', '员工分销', '导购分销'][scope.row.policyType] || '/'}</div>;
                  },
                },
              }}
            />
            <el-table-column prop="tagName" width="120" label="角色标签" show-overflow-tooltip />
            <el-table-column prop="childGoodsNum" width="120" sortable label="成交商品数" />
            <el-table-column
              prop="childPrice"
              width="120"
              sortable
              label="成交金额"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div>￥{scope.row.childPrice}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="superior"
              width="120"
              sortable
              label="上级分成"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div>￥{scope.row.superior}</div>;
                  },
                },
              }}
            />
          </el-table>
        </div>
      </div>
    );
  }
}
